export default "__VITE_ASSET__Dj$MlHMk__"